/* eslint-disable */
import React, { FC, ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../../redux/rootReducer';
import OfferHeader from '../common/OfferHeader/OfferHeader';
import withLocalization from '../hoc/withLocalization';
import ParseHtml from '../common/ParseHtml';
import './NewOfferError.scss';
import { resetOfferSearch, resetProspectDetails } from '../../features/offerSearch/offerSearchSlice';
import { resetPinOptFlowDetails } from '../../features/OfferValidateContainer/PinOptFlowOfferSlice';
import phoneLogo from '../../features/siteTheme/Brands/tmvcs/logo/intl-phoneLogo.svg';
import { useCountryCodeByName } from '../../util/useCountryCodeByName';
import isAsia from '../../util/isAsia';
import { resetShowCTA } from '../../features/offerSearch/offerSearchSlice';
import { getSafeTelHref } from '../../util/CommonLogic';
import {
  resetPaymentData,
  clearPaymentPage,
  clearPayerAuthDetails,
  resetAllPaymentPageDetails,
} from '../../features/OfferPaymentContainer/OfferPaymentSlice';
interface TestDetailProps {
  history: any;
  localize: any;
  phone?: any;
  localizeImages?: any;
}

const NewOfferError: FC<any> = (props: TestDetailProps): ReactElement => {
  const { localize, localizeImages } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData: any = location?.state || {};
  const callCenterCode = stateData?.callCenterCode || '';

  const offerDetails: any = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const prospectDetails = useSelector((state: RootState) => state.offerDetails.prospect);
  const errorCode: any = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentErrorStatus);

  const pinOfferData: any = (offerDetails?.offers && offerDetails?.offers[0]) || {};
  const pinPhNo = pinOfferData?.offerPhoneNumber || '';
  const dialCode = useCountryCodeByName(prospectDetails?.countryCode);
  const PhoneNo = pinPhNo ? `${dialCode}${pinPhNo}` : '';
  const { path } = localizeImages('preview-sales-engine.static-content.images.not-my-info-hero', 0, '7:3');
  const styleBg = {
    backgroundImage: `url("${path}")`,
  };
  const defaultPhNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const whatsAppImgData = localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const whatsAppPath = whatsAppImgData?.path || '';
  const defaultLink = defaultChatLinkText || '';
  const LogoPath = props.localizeImages('preview-sales-engine.static-content.images.mvc-logo', 0, '5:1');
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;

  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.errorPhone`;
  const callCenterDefault = `${localize(jahiaCallcenter)}`;

  //const callCentNo = stateNo || callCenterDefault;
  const callCentNo = callCenterDefault || defaultPhNo;
  const chatLinkText: any = localize(jahiaKey) || defaultLink;
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(resetPaymentData());
    dispatch(clearPaymentPage());
    dispatch(clearPayerAuthDetails());
    dispatch(resetAllPaymentPageDetails());
    dispatch(resetOfferSearch());
    dispatch(resetPinOptFlowDetails());
    dispatch(resetProspectDetails());
    dispatch(resetShowCTA(false));

    sessionStorage.clear();
  }, [dispatch]);

  const getErrMsg = (): string => {
    switch (errorCode) {
      case 'IIB_Error':
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.credit-card-declined-generic`);
      default:
        return localize(`preview-sales-engine.static-content.copy.Labels.error-message.credit-card-declined-system`);
    }
  };
  const handleKeyDown = () => {};
  const handleClickChatLink = (e: any) => {
    e.preventDefault();
    //window.location.href = chatLinkText;
    window.open(chatLinkText, '_blank');
    window.dataLayer.push({
      event: 'whatsapp',
    });
  };
  return (
    <>
      <OfferHeader phone={callCentNo} />
      <div className="pinFlowOpt-err-Main-container">
        <div className="pin-err-img-wrapper">
          <div className="image-pin-err-container" style={styleBg}></div>
        </div>
        <div className="payment-error-details-container">
          <ParseHtml
            htmlInput={localize(
              'preview-sales-engine.static-content.copy.Labels.error-message.pbeo.intl-generic-error-message',
            )}
          />
        </div>
        <div className="stop-Payment-err-phone-container">
          <div className="pinOpt-err-phone-link">
            <a className="payment-err-phone-anchor" href={encodeURI(getSafeTelHref(callCentNo))}>
              <img
                onKeyDown={handleKeyDown}
                tabIndex={0}
                src={phoneLogo}
                alt="Call Now"
                className="pinOpt-err-phone-icon"
              />
              <span
                aria-label={'phone-err-call'}
                onKeyDown={handleKeyDown}
                tabIndex={0}
                className="payment-err-phone"
              >{`+${callCentNo}`}</span>
            </a>
            {chatLinkText && (
              <>
                <div className="header-pipe">|</div>
                <a href={'#'} onClick={handleClickChatLink}>
                  <img className="desk-phone-img" src={whatsAppPath} alt="whatsapp" />
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default withLocalization(NewOfferError);
